import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { PER_PAGE } from '@/helpers/constants/app';
let PaginatorMixin = class PaginatorMixin extends Vue {
    displayPaginator(total) {
        return total > PER_PAGE;
    }
};
PaginatorMixin = __decorate([
    Component
], PaginatorMixin);
export default PaginatorMixin;
